import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

import { grid, distances } from '../../../styles/constants';
import { Order } from '../../../types/orders';
import Modal from '../../../components/Modal';
import { H1 } from '../../../components/Typography';
import { Button } from '../../../components/Buttons';
import { OperationLineItem } from '../../types';
import { formatMoney } from '../../../helpers/formatters';

export interface SuccessProps extends WithTranslation {
    order: Order;
    operationLineItems: OperationLineItem[];
    dismissModal: () => void;
}

const Success = (
    {
        order,
        operationLineItems,
        dismissModal,
        t,
        i18n,
    }: SuccessProps
) => {
    const amount = operationLineItems.reduce((sum, item) => sum + item.amount, 0);
    return (
        <Modal>
            <Wrapper>
                <SuccessIcon />
                <SuccessHeader>
                    {t('orders.cancel.success.title', {
                        amount: formatMoney(i18n.language, amount, order.currency),
                    })}
                </SuccessHeader>
                <Button onClick={dismissModal}>{t('orders.cancel.success.button_ok')}</Button>
            </Wrapper>
        </Modal>
    );
};

export default withTranslation()(Success);

const Wrapper = styled.div`
    position: relative;
    min-width: ${grid.spans.span5};
`;

const SuccessHeader = styled(H1)`
    text-align: center;
    margin-bottom: ${distances.normal};
`;

const SuccessIcon = styled.div`
    background-image: url(/assets/icons/icon_check_circle_primary.svg);
    height: 80px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin: ${distances.normal};
`;
